var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 17.2357C5.23857 17.2357 1.76428 13.7614 1.76428 9.5C1.76429 5.23857 5.23857 1.76429 9.5 1.76429C11.5505 1.76788 13.5161 2.58404 14.966 4.03399C16.416 5.48394 17.2321 7.44946 17.2357 9.5C17.2357 13.7614 13.7614 17.2357 9.5 17.2357ZM9.5 19C14.7386 19 19 14.7386 19 9.5C19 4.26143 14.7386 1.53546e-06 9.5 1.07829e-06C4.26143 6.21123e-07 -6.16597e-07 4.26143 -1.07537e-06 9.5C-1.53415e-06 14.7386 4.26143 19 9.5 19ZM8.14286 14.9286L10.8571 14.9286L10.8571 8.14286L8.14286 8.14286L8.14286 14.9286ZM8.14286 6.78571L10.8571 6.78571L10.8571 4.07143L8.14286 4.07143L8.14286 6.78571Z",
    fill: "#0D3688"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPrimary);
export default __webpack_public_path__ + "static/media/info_primary.a6f715dff20bedc0cf9ba8995a5bd515.svg";
export { ForwardRef as ReactComponent };